import request from '../utils/request.js'
//获取首页JSON数据
export function pageModule(data) {
  return request({
    url: process.env.PRODUCTURL + '/page/index',
    method: 'get',
  })
}
//获取商品分类数据
export function categoryModule(data) {
  return request({
    url: process.env.PRODUCTURL + '/page/index/getFeedsModule',
    method: 'post',
    data: data
  })
}
//获取公共footer
export function getFooter(data) {
  return request({
    url: '/view/mark/footer.html',
    method: 'get'
  })
}
//获取购物车数量
export function cartCount() {
  return request({
    url: '/cart/goods/count',
    method: 'get'
  })
}
//预览page页面
export function pageIdModule(data) {
  return request({
    url: process.env.PRODUCTURL + '/page/index/' + data,
    method: 'get',
  })
}

//新人活动
export function newUserActivity(data) {
  return request({
    url: process.env.SALEURL + '/api/newUserActivity',
    method: 'get',
    header: {
      'content-type': 'application/json', // 默认值
      'Cookie' : 'hdu='+ data
    },
  })
}
//未关注公众号提示
export function getNotifyByPageType(data) {
  return request({
    url: process.env.I_URL + '/api/goods/getNotifyByPageType?pageType=1',
    method: 'get',
    header: {
      'content-type': 'application/json', // 默认值
      'Cookie' : 'hdu='+ data
    },
  })
}


//获取优惠券弹窗
export function getPopCoupon(currenturl,data) {
  console.log("优惠券请求参数data----------",data)
  return request({
    url: process.env.SALEURL + '/coupon/getPopCoupon?requestUrl=' + currenturl,
    method: 'get',
    header: {
      'content-type': 'application/json', // 默认值
    },
  })
}

//领取优惠券
export function getCoupon(url) {
  return request({
    url:process.env.SALEURL +  url,
    method: 'post',
    header: {
      'content-type': 'application/json', // 默认值
    }
  })
}
//猜你喜欢
export function guessLike(data) {
  return request({
    url: process.env.PRODUCTURL + '/page/index/getAirecGoods',
    method: 'get'
  })
}

//获取搜索词默认词
export function getSearchDefault(data) {
  return request({
    url: process.env.I_URL + '/api/goods/default',
    method: 'get'
  })
}


//检测是否加微信好友
export function findEnterpriseWeChat(uid) {
  return request({
    url: process.env.MYURL + '/mall/findEnterpriseWeChat?uid=' + uid,
    method: 'get'
  })
}



//获取小程序跳转链接
export function generatescheme(data) {
  return request({
    url: 'https://w.reflower.com.cn/mini/generatescheme',
    method: 'get',
    params:data
  })
}


//获取拉新图片
export function getLaxinConfig() {
  return request({
    url: process.env.I_URL + '/api/goods/laxinConfig',
    method: 'get'
  })
}


// WEBPACK FOOTER //
// ./src/api/index.js